module.exports = __webpack_public_path__ + "img/Tessellate57.5d4601b5.jpg";